// Downloadable CSV template generators

import { downloadCSV } from './exportUtils';

export function downloadIngredientTemplate() {
  const headers = ['Name', 'Vendor', 'Category', 'Purchase Cost', 'Purchase Quantity', 'Purchase Unit', 'Yield Percent', 'Notes'];
  const rows = [
    ['Mozzarella Cheese', 'Sysco', 'Dairy', '48.50', '10', 'lb', '95', 'Low moisture, shredded'],
    ['Pizza Dough Flour', 'US Foods', 'Dry Goods', '32.00', '50', 'lb', '98', '00 flour'],
    ['Pepperoni', 'Sysco', 'Meat', '42.00', '10', 'lb', '100', 'Sliced, cup & char'],
    ['Tomato Sauce', 'Sysco', 'Sauces', '5.80', '106', 'oz', '100', '#10 can crushed'],
    ['Pizza Box 14"', 'Restaurant Depot', 'Packaging', '42.00', '50', 'each', '100', 'Corrugated'],
  ];
  downloadCSV('pizzalator-ingredient-template', headers, rows);
}

export function downloadRecipeTemplate() {
  const headers = ['Recipe Name', 'Category', 'Menu Price', 'Packaging Cost', 'Prep Minutes', 'Cook Minutes', 'Hourly Wage', 'Labor Burden %', 'Ingredient 1', 'Amount 1', 'Unit 1', 'Ingredient 2', 'Amount 2', 'Unit 2', 'Ingredient 3', 'Amount 3', 'Unit 3', 'Notes'];
  const rows = [
    ['Large Cheese Pizza', 'Pizza', '16.99', '0.84', '5', '12', '16', '25', 'Pizza Dough Flour', '18', 'oz', 'Mozzarella Cheese', '8', 'oz', 'Tomato Sauce', '6', 'oz', 'Our #1 seller'],
    ['Large Pepperoni Pizza', 'Pizza', '19.99', '0.84', '6', '12', '16', '25', 'Pizza Dough Flour', '18', 'oz', 'Mozzarella Cheese', '8', 'oz', 'Pepperoni', '3', 'oz', 'Crowd favorite'],
  ];
  downloadCSV('pizzalator-recipe-template', headers, rows);
}
